import React, { useState } from 'react';

import DefaultSelect from 'components/select/DefaultSelect';
import DropZoneZip from 'components/dropzoneUpload/DropZoneZip';
import { Form } from 'antd';
import SmallModal from 'components/form/SmallModal';
import SubmitButton from 'components/button/SubmitButton';
import VerticalForm from 'components/form/DefaultForm';

/**
 *
 * @returns {플랫폼 사운드 한 번에 올리기 (zip 파일) 모달}
 */
const PlatformSoundZipModal = ({
  visible,
  setVisible,
  fetchData,
  optionList,
  selectSoundType,
  setSelectSoundType,
}) => {
  const [inputDatas, setInputDatas] = useState({
    sound_name: '',
    sound_type: 'se',
  });
  const [file, setFile] = useState(null);
  const [form] = Form.useForm();

  const handleClose = () => {
    setVisible(false);
    form.resetFields();
    setFile('');
  };

  /// 사운드 타입 드롭다운
  const handleChangeSoundType = (value) => {
    setSelectSoundType(value);
  };

  const handleSubmit = async () => {
    const formData = new FormData();
    formData.append('uploadFile', file);
    formData.append('sound_type', selectSoundType);
    // const res = await platformSoundRegister(formData);
    setVisible(false);
    setFile(null);

    form.resetFields(); // 드롭존 이미지를 비우기 위해 필요하다.
    fetchData();
  };
  return (
    <SmallModal
      title='플랫폼 사운드 등록'
      visible={visible}
      onCancel={handleClose}
    >
      <VerticalForm form={form} drop>
        <Form.Item label='사운드 타입'>
          <DefaultSelect
            optionList={optionList}
            value={selectSoundType}
            onChange={handleChangeSoundType}
          />
        </Form.Item>
        <Form.Item name='uploadFile'>
          <DropZoneZip setFile={setFile} zipMemo='mp3' />
        </Form.Item>
        <SubmitButton onClick={handleSubmit}>등록하기</SubmitButton>
      </VerticalForm>
    </SmallModal>
  );
};

export default PlatformSoundZipModal;
